import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { getFaireMarketUtils } from "@faire/web--source/common/promotional-events/getFaireMarketUtils";
import { Row } from "@faire/web--source/slate/Layout";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { EventsThemeLogo } from "@faire/web--source/slate/Theme/EventsThemeLogo";
import { EventsThemeShape } from "@faire/web--source/slate/Theme/EventsThemeShape";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
export var BrandsLandingPageFaireMarketShowcase = function() {
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        mobile: /*#__PURE__*/ _jsxs(MobileContainer, {
            children: [
                /*#__PURE__*/ _jsx(StyledMarketBadge, {}),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "2x"
                }),
                /*#__PURE__*/ _jsx(TextContainer, {})
            ]
        }),
        tabletAndAbove: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsx(LogoContainer, {}),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "3x"
                }),
                /*#__PURE__*/ _jsx(TextContainer, {})
            ]
        })
    });
};
var LogoContainer = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var getLocalizedDateIncludingFrom = getFaireMarketUtils(undefined, strictLocalize).getLocalizedDateIncludingFrom;
    var latestMarketEarlyAccessRangeDate = useMarketStore([
        "latestMarketEarlyAccessRangeDate"
    ]).latestMarketEarlyAccessRangeDate;
    return /*#__PURE__*/ _jsxs(LogoContainerWrapper, {
        children: [
            /*#__PURE__*/ _jsx(StyledMarketPrimaryLogo, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "6x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "paragraphSansMedium",
                    tabletAndAbove: "sectionHeaderSansMedium"
                },
                color: eventsThemeColors.faireMarket.promoText,
                children: getLocalizedDateIncludingFrom(latestMarketEarlyAccessRangeDate, strictLocalize)
            })
        ]
    });
};
var TextContainer = function() {
    return /*#__PURE__*/ _jsxs(TextContainerWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "subheadingSansMedium",
                    tabletAndAbove: "displayLSerifRegular"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "68LOSn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Showcase your brand at Faire Markets"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: "1x",
                    tabletAndAbove: "2x"
                }
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                variant: {
                    mobileAndAbove: "paragraphSansRegular",
                    tabletAndAbove: "subheadingSansRegular"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "1LUH98",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Our community comes together twice a year during Faire\u2019s online trade show events to buy, sell, and build new relationships around the world."
                        }
                    ]
                })
            })
        ]
    });
};
var MobileContainer = styled(Row).withConfig({
    componentId: "sc-c4cbd38f-0"
})([
    "padding:",
    ";"
], getSpacing(0, "3x", "4x"));
var Container = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-c4cbd38f-1"
})([
    "margin-bottom:",
    ";padding:",
    ";height:fit-content;width:100%;",
    "{padding:",
    ";}"
], getSpacing(96), getSpacing(0, "5x", "3x"), responsiveMediaQueries.mobile, getSpacing("3x", "3x", "2x"));
var LogoContainerWrapper = styled(Column).withConfig({
    componentId: "sc-c4cbd38f-2"
})([
    "background:",
    ";",
    "{padding:",
    ";width:430px;}",
    "{margin:",
    ";padding:",
    ";}"
], eventsThemeColors.faireMarket.lightBackground, responsiveMediaQueries.tabletAndAbove, getSpacing("9x", "8x", 88), responsiveMediaQueries.mobile, getSpacing(0, 55), getSpacing("4x", "5x"));
var TextContainerWrapper = styled(Column).withConfig({
    componentId: "sc-c4cbd38f-3"
})([
    "",
    "{padding-left:",
    ";width:455px;}"
], responsiveMediaQueries.tabletAndAbove, getSpacing("9x"));
var StyledMarketPrimaryLogo = styled(EventsThemeLogo.faireMarket.primary).withConfig({
    componentId: "sc-c4cbd38f-4"
})([
    "width:187px;height:150px;",
    "{width:93px;height:75px;}"
], responsiveMediaQueries.mobile);
var StyledMarketBadge = styled(EventsThemeShape.faireMarket.badge).attrs({
    width: "24px",
    height: "24px"
}).withConfig({
    componentId: "sc-c4cbd38f-5"
})([
    "margin-top:4px;"
]);
